import { render, staticRenderFns } from "./refferal.vue?vue&type=template&id=682437f7"
import script from "./refferal.vue?vue&type=script&lang=ts"
export * from "./refferal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports